import { render, staticRenderFns } from "./AssetBrowser.vue?vue&type=template&id=b8ca375e&scoped=true&"
import script from "./AssetBrowser.vue?vue&type=script&lang=js&"
export * from "./AssetBrowser.vue?vue&type=script&lang=js&"
import style0 from "./AssetBrowser.vue?vue&type=style&index=0&id=b8ca375e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ca375e",
  null
  
)

export default component.exports